import styled from "styled-components";

export const CpfContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 8px;
  font-size: 16px;
  border: ${(props) =>
    props.isError
      ? `1px solid ${props.theme.colors.danger}`
      : `1px solid ${props.theme.colors.border}`};
  border-radius: 4px;
  outline: none;

  &:focus {
    border-color: ${(props) =>
      props.isError ? props.theme.colors.danger : props.theme.colors.focus};
  }
`;

export const ErrorText = styled.p`
  color: ${(props) => props.theme.colors.danger};
  font-size: 12px;
  margin-top: 4px;
`;
